"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserActionPopup = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const ConfirmationPopup_1 = __importDefault(require("@Components/Popups/ConfirmationPopup"));
const UserActionPopup = (props) => {
    const { firstName, lastName, email } = props.user;
    const disabled = !!props.disabled;
    return (react_1.default.createElement(ConfirmationPopup_1.default, { title: props.title, onCancel: props.onCancel, onConfirm: props.onConfirm, cancelButtonText: "Cancel", confirmButtonText: "Confirm", disabled: disabled },
        react_1.default.createElement("div", { className: 'actions-container' },
            react_1.default.createElement("p", null,
                "Name: ",
                react_1.default.createElement("strong", { title: firstName + ' ' + lastName }, firstName + ' ' + lastName)),
            react_1.default.createElement("p", null,
                "Email: ",
                react_1.default.createElement("strong", { title: email }, email)))));
};
exports.UserActionPopup = UserActionPopup;
